import comp from "./StudentAlertsSection";
export default comp;
